
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import CoverageExplorer from 'src/components/docs/plaidoms/CoverageExplorer';
export const metadata = {
  toc: true,
  layout: 'guide',
  description: "Search for product coverage by institution"
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='European Bank Coverage Explorer' subtitle={metadata.description} mdxType="Header" />
    <p>{`Plaid provides reliable banking connections for businesses expanding across Europe. Unlike other providers relying on aggregation, Plaid delivers direct connections to nearly 2,000 European financial institutions—ensuring faster and more accurate performance.`}</p>
    <p>{`Our coverage explorer below can help you see which Plaid products are supported by different financial institutions. Note that not all products are available in all countries. See `}<a parentName="p" {...{
        "href": "https://support.plaid.com/hc/en-us/articles/27895826947735-What-Plaid-products-are-supported-in-each-country-and-region"
      }}>{`this article`}</a>{` for a complete list of what products are supported in each country.`}</p>
    <p>{`This data is updated approximately once a quarter and may not be completely up to date.
For the most complete data, use `}<inlineCode parentName="p">{`/institutions/get`}</inlineCode>{` or the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/activity/status/institution"
      }}>{`Institutions page`}</a>{` in the Dashboard. If you have specific institutional requirements, submit a request via the Plaid Dashboard. If you're interested in US or Canadian banks, see our `}<a parentName="p" {...{
        "href": "/docs/institutions/"
      }}>{`US and Canada Bank Coverage Explorer`}</a>{`.`}</p>
    <CoverageExplorer mdxType="CoverageExplorer" />
    <p><a parentName="p" {...{
        "href": "https://plaid.com/documents/eu_institution_coverage.csv"
      }}>{`Download this coverage as CSV`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
